export default __webpack_public_path__ + "static/media/BosaCrew1.44e941f6.jpg";